import { render, staticRenderFns } from "./Intranet.vue?vue&type=template&id=0a6bd29a&"
import script from "./Intranet.vue?vue&type=script&lang=ts&"
export * from "./Intranet.vue?vue&type=script&lang=ts&"
import style0 from "./Intranet.vue?vue&type=style&index=0&id=0a6bd29a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VContent } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VContainer,VContent,VFlex})
